
/** Un-normalised on purpose: every consumer runs it through `normalize()` in
 *  GLSL rather than being handed a pre-normalised constant, so there is only
 *  one function computing the actual unit vector and no chance of a shader
 *  quietly using the raw (non-unit) form by mistake. */
export const SUN_DIR_RAW: readonly [number, number, number] = [-0.45, 0.55, 0.85];

/** The GLSL expression for the sun direction, spelled out once and spliced
 *  into every shader that lights against it. */
export const SUN_DIR_GLSL = `normalize(vec3(${SUN_DIR_RAW[0]}, ${SUN_DIR_RAW[1]}, ${SUN_DIR_RAW[2]}))`;
